
import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader, CardBody, Input, Row, Col, CardTitle } from "reactstrap";
import useToken from "../../../helpers/useToken"
import TMHLoader from "../../TMHLoader/TMHLoader";

export default function AdvertisingBlackList({ notify, trigger }) {
    const { token } = useToken()
    const [blackList, setBlackList] = useState()
    const [totalBlackList, setTotalBlackList] = useState()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const initData = () => {
            setIsLoading(true)
            console.log('AdvertisingBlackList:: get data')
            const myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };

            fetch(process.env.REACT_APP_BASE_URL + "rewards/black_list", requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        // console.log(json)
                        if (result.ok) {
                            setBlackList(json.data)
                            setTotalBlackList(json.data.length)
                        }
                        else {
                            // console.log(result.json.message)

                        }
                        setIsLoading(false)
                    }
                )
        }

        initData()
    }, [token, trigger])

    const handleUpdateBlackList = async () => {
        setIsLoading(true)
        console.log('AdvertisingBlackList: PUT data')
        const myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify({
                'data': blackList
            })
        };

        fetch(process.env.REACT_APP_BASE_URL + "rewards/black_list", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                async (result) => {
                    var json = result.json
                    // console.log(json)
                    if (result.ok) {
                        setBlackList(json.data)
                        setTotalBlackList(json.data.length)
                        notify('tl', 'Save Black List Success!', 'success')
                    }
                    else {
                        // console.log(result.json.message)
                        notify('tl', 'Save Black List Failed: !' + json?.message, 'danger')
                    }
                    setIsLoading(false)
                }
            )
    }

    return (

        <TMHLoader active={isLoading}>
            <Card>
                <CardHeader>
                    <CardTitle className="text-center" tag="h2">
                        Advertising Black List ({totalBlackList})
                    </CardTitle>
                </CardHeader>
                <CardBody className="text-white">
                    <Row className="my-4">
                        <Col md="12">
                            Advertising Id (one Id per line):
                        </Col>
                        <Col>
                            <Input
                                className="p-2"
                                style={{ "maxHeight": 400 }}
                                value={blackList?.join('\n')}
                                onChange={(e) => setBlackList(e.target.value.split('\n'))}
                                type="textarea"
                                bsSize="lg"
                                rows="5000"
                                cols="50" />

                        </Col>

                    </Row>
                    <Row className="text-center">
                        <Col md="12">
                            <Button
                                onClick={() => handleUpdateBlackList()}
                                color="success">Update</Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </TMHLoader>
    );
}
